import React, { useState } from "react";
import { IoClose, IoVideocam } from "react-icons/io5"; // Import IoVideocam icon
import welcomeTopics from "../Welcome/welcomeTopics.json"; // Import help topics JSON
import thisIsFocusMap from "../assets/videos/this-is-focusmap.mp4";
import introduction from "../assets/videos/introduction.mp4";
import { IoHelpCircle } from "react-icons/io5"; // Import the help icon
import HelpModal from "../Components/HelpModal"; // Import the HelpModal component

interface HelpModalProps {
  showHelpModal: boolean;
  setShowHelpModal: (value: boolean) => void;
  onClose: (value: boolean) => void;
  setDoNotShowAgain: (value: boolean) => void;
}

const WelcomeModal: React.FC<HelpModalProps> = ({
  showHelpModal,
  setShowHelpModal,
  onClose,
  setDoNotShowAgain,
}) => {
  const [selectedHelpTopic, setSelectedHelpTopic] = useState<string | null>(
    null
  );


  const handleHelpTopicClick = (topic: string) => {
    setSelectedHelpTopic(topic);
  };

  const handleCloseVideoModal = () => {
    setSelectedHelpTopic(null);
  };

  const handleHelp = () => {
    onClose(true);
  };

  return (
    <>
      {showHelpModal && (
        <div className="modal">
          <div className="welcome-modal-content">
            <button className="welcome-modal-close-button" onClick={() => onClose(false)}>
              <IoClose size={20} />
            </button>
            <h2 className="welcome-modal-title">Welcome to FocusMap!</h2>
            <p className="welcome-modal-description">
              We’re excited to have you here!
            </p>
            <p className="welcome-modal-description">
              Start your journey by exploring our videos on how to organize your
              ideas, boost productivity, and achieve your goals. Ready to dive
              in?
            </p>
            {/* <ul className="welcome-topic-list">
              {welcomeTopics.map((topic, index) => (
                <li
                  key={index}
                  onClick={() => handleHelpTopicClick(topic.url)}
                  className={`welcome-topic-item ${topic.disabled ? "disabled" : ""
                    }`}
                >
                  <span>{topic.title}</span>
                  <IoVideocam size={20} color="white" className="video-icon" />
                </li>
              ))}
            </ul> */}

            <button className="welcome-help-button" onClick={handleHelp}>
              <IoHelpCircle size={64} />
            </button>

            <div className="welcome-modal-footer">
              <div className="welcome-row">
                <label>
                  <input
                    type="checkbox"
                    className="do-not-show-again-checkbox"
                    onChange={(e) => setDoNotShowAgain(e.target.checked)}
                  />
                </label>
                <div className="checkbox-label">Do not show again</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedHelpTopic && (
        <div className="video-modal">
          <div className="video-modal-content">
            <button
              className="welcome-video-modal-close-button"
              onClick={handleCloseVideoModal}
            >
              <IoClose size={20} />
            </button>
            <video controls autoPlay className="video-player">
              <source src={selectedHelpTopic} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </>
  );
};

export default WelcomeModal;
